import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBodySpleen = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M4.55667 18.875C4.303 18.875 4.05181 18.825 3.81745 18.728C3.58309 18.6309 3.37014 18.4886 3.19077 18.3092C3.0114 18.1299 2.86911 17.9169 2.77204 17.6825C2.67496 17.4482 2.625 17.197 2.625 16.9433V11.375C2.625 9.05436 3.54687 6.82876 5.18782 5.18782C6.82876 3.54687 9.05436 2.625 11.375 2.625H18.845C19.516 2.625 20.1595 2.89155 20.634 3.36602C21.1084 3.84049 21.375 4.484 21.375 5.155C21.375 6.23031 21.0283 7.27698 20.3864 8.13969C19.7446 9.0024 18.8416 9.63519 17.8117 9.94417L11.4617 11.8492C10.6449 12.094 9.88687 12.5034 9.23422 13.0522C8.58157 13.6009 8.04811 14.2774 7.66667 15.04L6.28333 17.8075C6.12287 18.1281 5.87639 18.3977 5.57146 18.5862C5.26653 18.7747 4.91517 18.8747 4.55667 18.875V18.875Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.3042 17.7667C8.11503 17.8858 11.375 17.66 11.375 14.5C11.375 14.5 16.9025 15.6058 17.5609 10.0192"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.875 17.5775V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.375 14.5V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.875 2.625C12 2.625 10.125 4.5 10.125 7.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBodySpleen.displayName = 'SvgBodySpleen';
export default SvgBodySpleen;
